export const FormatsData: import('../../../sim/dex-species').ModdedSpeciesFormatsDataTable = {
	bulbasaur: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ivysaur: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	venusaur: {
		tier: "UU",
	},
	venusaurmega: {
		tier: "UU",
	},
	venusaurgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	charmander: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	charmeleon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	charizard: {
		tier: "UU",
	},
	charizardmegax: {
		tier: "UUBL",
	},
	charizardmegay: {
		tier: "UUBL",
	},
	charizardgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	squirtle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	wartortle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	blastoise: {
		tier: "UU",
	},
	blastoisemega: {
		tier: "Uber",
	},
	blastoisegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	caterpie: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	metapod: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	butterfree: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	butterfreegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	weedle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kakuna: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	beedrill: {
		tier: "UU",
	},
	beedrillmega: {
		tier: "UU",
	},
	pidgey: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pidgeotto: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pidgeot: {
		tier: "UU",
	},
	pidgeotmega: {
		tier: "UU",
	},
	rattata: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	rattataalola: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	raticate: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	raticatealola: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	raticatealolatotem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	spearow: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	fearow: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ekans: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	arbok: {
		tier: "UU",
	},
	pichu: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pichuspikyeared: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachu: {
		tier: "NFE",
	},
	pikachucosplay: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachurockstar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachubelle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachupopstar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachuphd: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachulibre: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachuoriginal: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachuhoenn: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachusinnoh: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachuunova: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachukalos: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachualola: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachupartner: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachustarter: {
		isNonstandard: "LGPE",
		tier: "Illegal",
	},
	pikachugmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pikachuworld: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	raichu: {
		tier: "UU",
	},
	raichualola: {
		tier: "UU",
	},
	raichumegax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	raichumegay: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sandshrew: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sandshrewalola: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sandslash: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sandslashalola: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	nidoranf: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	nidorina: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	nidoqueen: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	nidoranm: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	nidorino: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	nidoking: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cleffa: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	clefairy: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	clefable: {
		tier: "OU",
	},
	clefablemega: {
		tier: "(OU)",
	},
	vulpix: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	vulpixalola: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ninetales: {
		tier: "UU",
	},
	ninetalesalola: {
		tier: "UU",
	},
	igglybuff: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	jigglypuff: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	wigglytuff: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zubat: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	golbat: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	crobat: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	oddish: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	gloom: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	vileplume: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	bellossom: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	paras: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	parasect: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	venonat: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	venomoth: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	diglett: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	diglettalola: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dugtrio: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dugtrioalola: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	meowth: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	meowthalola: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	meowthgalar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	meowthgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	persian: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	persianalola: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	perrserker: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	psyduck: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	golduck: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mankey: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	primeape: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	growlithe: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	growlithehisui: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	arcanine: {
		tier: "UU",
	},
	arcaninehisui: {
		tier: "UU",
	},
	poliwag: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	poliwhirl: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	poliwrath: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	politoed: {
		tier: "UU",
	},
	abra: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kadabra: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	alakazam: {
		tier: "UU",
	},
	alakazammega: {
		tier: "UUBL",
	},
	machop: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	machoke: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	machamp: {
		tier: "UU",
	},
	machampgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	bellsprout: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	weepinbell: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	victreebel: {
		tier: "UU",
	},
	victreebelmega: {
		tier: "UU",
	},
	tentacool: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tentacruel: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	geodude: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	geodudealola: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	graveler: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	graveleralola: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	golem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	golemalola: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ponyta: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ponytagalar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	rapidash: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	rapidashgalar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	slowpoke: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	slowpokegalar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	slowbro: {
		tier: "UU",
	},
	slowbromega: {
		tier: "UU",
	},
	slowbrogalar: {
		tier: "UU",
	},
	slowking: {
		tier: "UU",
	},
	slowkinggalar: {
		tier: "OU",
	},
	magnemite: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	magneton: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	magnezone: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	farfetchd: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	farfetchdgalar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sirfetchd: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	doduo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dodrio: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	seel: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dewgong: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	grimer: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	grimeralola: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	muk: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mukalola: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	shellder: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cloyster: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	gastly: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	haunter: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	gengar: {
		tier: "UU",
	},
	gengarmega: {
		tier: "Uber",
	},
	gengargmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	onix: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	steelix: {
		tier: "UU",
	},
	steelixmega: {
		tier: "UU",
	},
	drowzee: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	hypno: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	krabby: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kingler: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kinglergmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	voltorb: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	voltorbhisui: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	electrode: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	electrodehisui: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	exeggcute: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	exeggutor: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	exeggutoralola: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cubone: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	marowak: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	marowakalola: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	marowakalolatotem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tyrogue: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	hitmonlee: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	hitmonchan: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	hitmontop: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	lickitung: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	lickilicky: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	koffing: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	weezing: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	weezinggalar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	rhyhorn: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	rhydon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	rhyperior: {
		tier: "UU",
	},
	happiny: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	chansey: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	blissey: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tangela: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tangrowth: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kangaskhan: {
		tier: "UU",
	},
	kangaskhanmega: {
		tier: "UU",
	},
	horsea: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	seadra: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kingdra: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	goldeen: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	seaking: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	staryu: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	starmie: {
		tier: "UU",
	},
	starmiemega: {
		tier: "Uber",
	},
	mimejr: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mrmime: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mrmimegalar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mrrime: {
		tier: "UU",
	},
	scyther: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	scizor: {
		tier: "OU",
	},
	scizormega: {
		tier: "OU",
	},
	kleavor: {
		tier: "UU",
	},
	smoochum: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	jynx: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	elekid: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	electabuzz: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	electivire: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	magby: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	magmar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	magmortar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pinsir: {
		tier: "UU",
	},
	pinsirmega: {
		tier: "UU",
	},
	tauros: {
		tier: "UU",
	},
	taurospaldeacombat: {
		tier: "UU",
	},
	taurospaldeablaze: {
		tier: "UU",
	},
	taurospaldeaaqua: {
		tier: "UU",
	},
	magikarp: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	gyarados: {
		tier: "UU",
	},
	gyaradosmega: {
		tier: "UU",
	},
	lapras: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	laprasgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ditto: {
		tier: "OU",
	},
	eevee: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	eeveestarter: {
		isNonstandard: "LGPE",
		tier: "Illegal",
	},
	eeveegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	vaporeon: {
		tier: "UU",
	},
	jolteon: {
		tier: "UU",
	},
	flareon: {
		tier: "UU",
	},
	espeon: {
		tier: "UU",
	},
	umbreon: {
		tier: "UU",
	},
	leafeon: {
		tier: "UU",
	},
	glaceon: {
		tier: "UU",
	},
	sylveon: {
		tier: "UU",
	},
	porygon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	porygon2: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	porygonz: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	omanyte: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	omastar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kabuto: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kabutops: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	aerodactyl: {
		tier: "UU",
	},
	aerodactylmega: {
		tier: "UU",
	},
	munchlax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	snorlax: {
		tier: "UU",
	},
	snorlaxgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	articuno: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	articunogalar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zapdos: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zapdosgalar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	moltres: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	moltresgalar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dratini: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dragonair: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dragonite: {
		tier: "OU",
	},
	dragonitemega: {
		tier: "(OU)",
	},
	mewtwo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mewtwomegax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mewtwomegay: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mew: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	chikorita: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	bayleef: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	meganium: {
		tier: "UU",
	},
	meganiummega: {
		tier: "OU",
	},
	cyndaquil: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	quilava: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	typhlosion: {
		tier: "UU",
	},
	typhlosionhisui: {
		tier: "UU",
	},
	totodile: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	croconaw: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	feraligatr: {
		tier: "UU",
	},
	feraligatrmega: {
		tier: "UU",
	},
	sentret: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	furret: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	hoothoot: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	noctowl: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ledyba: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ledian: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	spinarak: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ariados: {
		tier: "UU",
	},
	chinchou: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	lanturn: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	togepi: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	togetic: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	togekiss: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	natu: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	xatu: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mareep: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	flaaffy: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ampharos: {
		tier: "UU",
	},
	ampharosmega: {
		tier: "UU",
	},
	azurill: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	marill: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	azumarill: {
		tier: "UU",
	},
	bonsly: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sudowoodo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	hoppip: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	skiploom: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	jumpluff: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	aipom: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ambipom: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sunkern: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sunflora: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	yanma: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	yanmega: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	wooper: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	wooperpaldea: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	quagsire: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	murkrow: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	honchkrow: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	misdreavus: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mismagius: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	unown: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	wynaut: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	wobbuffet: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	girafarig: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	farigiraf: {
		tier: "UU",
	},
	pineco: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	forretress: {
		tier: "UU",
	},
	dunsparce: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dudunsparce: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dudunsparcethreesegment: {
		isNonstandard: "Past",
	},
	gligar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	gliscor: {
		tier: "UU",
	},
	snubbull: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	granbull: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	qwilfish: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	qwilfishhisui: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	overqwil: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	shuckle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	heracross: {
		tier: "UU",
	},
	heracrossmega: {
		tier: "UU",
	},
	sneasel: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sneaselhisui: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	weavile: {
		tier: "UU",
	},
	sneasler: {
		tier: "OU",
	},
	teddiursa: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ursaring: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ursaluna: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ursalunabloodmoon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	slugma: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	magcargo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	swinub: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	piloswine: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mamoswine: {
		tier: "UU",
	},
	corsola: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	corsolagalar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cursola: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	remoraid: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	octillery: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	delibird: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mantyke: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mantine: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	skarmory: {
		tier: "UU",
	},
	skarmorymega: {
		tier: "UU",
	},
	houndour: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	houndoom: {
		tier: "UU",
	},
	houndoommega: {
		tier: "UU",
	},
	phanpy: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	donphan: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	stantler: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	wyrdeer: {
		tier: "UU",
	},
	smeargle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	miltank: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	raikou: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	entei: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	suicune: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	larvitar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pupitar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tyranitar: {
		tier: "UU",
	},
	tyranitarmega: {
		tier: "UU",
	},
	lugia: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	hooh: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	celebi: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	treecko: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	grovyle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sceptile: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sceptilemega: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	torchic: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	combusken: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	blaziken: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	blazikenmega: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mudkip: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	marshtomp: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	swampert: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	swampertmega: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	poochyena: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mightyena: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zigzagoon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zigzagoongalar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	linoone: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	linoonegalar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	obstagoon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	wurmple: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	silcoon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	beautifly: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cascoon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dustox: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	lotad: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	lombre: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ludicolo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	seedot: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	nuzleaf: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	shiftry: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	taillow: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	swellow: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	wingull: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pelipper: {
		tier: "OU",
	},
	ralts: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kirlia: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	gardevoir: {
		tier: "UU",
	},
	gardevoirmega: {
		tier: "UU",
	},
	gallade: {
		tier: "UU",
	},
	gallademega: {
		tier: "UU",
	},
	surskit: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	masquerain: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	shroomish: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	breloom: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	slakoth: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	vigoroth: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	slaking: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	nincada: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ninjask: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	shedinja: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	whismur: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	loudred: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	exploud: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	makuhita: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	hariyama: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	nosepass: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	probopass: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	skitty: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	delcatty: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sableye: {
		tier: "UU",
	},
	sableyemega: {
		tier: "UU",
	},
	mawile: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mawilemega: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	aron: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	lairon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	aggron: {
		tier: "UU",
	},
	aggronmega: {
		tier: "UU",
	},
	meditite: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	medicham: {
		tier: "UU",
	},
	medichammega: {
		tier: "UU",
	},
	electrike: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	manectric: {
		tier: "UU",
	},
	manectricmega: {
		tier: "UU",
	},
	plusle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	minun: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	volbeat: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	illumise: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	budew: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	roselia: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	roserade: {
		tier: "UU",
	},
	gulpin: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	swalot: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	carvanha: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sharpedo: {
		tier: "UU",
	},
	sharpedomega: {
		tier: "UU",
	},
	wailmer: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	wailord: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	numel: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	camerupt: {
		tier: "UU",
	},
	cameruptmega: {
		tier: "UU",
	},
	torkoal: {
		tier: "UU",
	},
	spoink: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	grumpig: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	spinda: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	trapinch: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	vibrava: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	flygon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cacnea: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cacturne: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	swablu: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	altaria: {
		tier: "UU",
	},
	altariamega: {
		tier: "UU",
	},
	zangoose: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	seviper: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	lunatone: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	solrock: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	barboach: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	whiscash: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	corphish: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	crawdaunt: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	baltoy: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	claydol: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	lileep: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cradily: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	anorith: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	armaldo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	feebas: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	milotic: {
		tier: "UU",
	},
	castform: {
		tier: "UU",
	},
	castformsunny: {
	},
	castformrainy: {
	},
	castformsnowy: {
	},
	kecleon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	shuppet: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	banette: {
		tier: "UU",
	},
	banettemega: {
		tier: "UU",
	},
	duskull: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dusclops: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dusknoir: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tropius: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	chingling: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	chimecho: {
		tier: "UU",
	},
	chimechomega: {
		tier: "UU",
	},
	absol: {
		tier: "UU",
	},
	absolmega: {
		tier: "UU",
	},
	absolmegaz: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	snorunt: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	glalie: {
		tier: "UU",
	},
	glaliemega: {
		tier: "UU",
	},
	froslass: {
		tier: "UU",
	},
	froslassmega: {
		tier: "UU",
	},
	spheal: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sealeo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	walrein: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	clamperl: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	huntail: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	gorebyss: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	relicanth: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	luvdisc: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	bagon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	shelgon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	salamence: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	salamencemega: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	beldum: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	metang: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	metagross: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	metagrossmega: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	regirock: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	regice: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	registeel: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	latias: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	latiasmega: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	latios: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	latiosmega: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kyogre: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kyogreprimal: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	groudon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	groudonprimal: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	rayquaza: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	rayquazamega: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	jirachi: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	deoxys: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	deoxysattack: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	deoxysdefense: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	deoxysspeed: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	turtwig: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	grotle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	torterra: {
		tier: "UU",
	},
	chimchar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	monferno: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	infernape: {
		tier: "UU",
	},
	piplup: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	prinplup: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	empoleon: {
		tier: "UU",
	},
	starly: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	staravia: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	staraptor: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	staraptormega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	bidoof: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	bibarel: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kricketot: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kricketune: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	shinx: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	luxio: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	luxray: {
		tier: "UU",
	},
	cranidos: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	rampardos: {
		tier: "UU",
	},
	shieldon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	bastiodon: {
		tier: "UU",
	},
	burmy: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	wormadam: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	wormadamsandy: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	wormadamtrash: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mothim: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	combee: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	vespiquen: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pachirisu: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	buizel: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	floatzel: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cherubi: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cherrim: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cherrimsunshine: {
		isNonstandard: "Past",
	},
	shellos: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	gastrodon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	drifloon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	drifblim: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	buneary: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	lopunny: {
		tier: "UU",
	},
	lopunnymega: {
		tier: "OU",
	},
	glameow: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	purugly: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	stunky: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	skuntank: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	bronzor: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	bronzong: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	chatot: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	spiritomb: {
		tier: "UU",
	},
	gible: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	gabite: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	garchomp: {
		tier: "OU",
	},
	garchompmega: {
		tier: "(OU)",
	},
	garchompmegaz: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	riolu: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	lucario: {
		tier: "UU",
	},
	lucariomega: {
		tier: "Uber",
	},
	lucariomegaz: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	hippopotas: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	hippowdon: {
		tier: "UU",
	},
	skorupi: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	drapion: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	croagunk: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	toxicroak: {
		tier: "UU",
	},
	carnivine: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	finneon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	lumineon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	snover: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	abomasnow: {
		tier: "UU",
	},
	abomasnowmega: {
		tier: "UU",
	},
	rotom: {
		tier: "UU",
	},
	rotomheat: {
		tier: "UU",
	},
	rotomwash: {
		tier: "OU",
	},
	rotomfrost: {
		tier: "UU",
	},
	rotomfan: {
		tier: "UU",
	},
	rotommow: {
		tier: "UU",
	},
	uxie: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mesprit: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	azelf: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dialga: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dialgaorigin: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	palkia: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	palkiaorigin: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	heatran: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	heatranmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	regigigas: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	giratina: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	giratinaorigin: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cresselia: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	phione: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	manaphy: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	darkrai: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	darkraimega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	shaymin: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	shayminsky: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	arceus: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	arceusbug: {
		isNonstandard: "Past",
	},
	arceusdark: {
		isNonstandard: "Past",
	},
	arceusdragon: {
		isNonstandard: "Past",
	},
	arceuselectric: {
		isNonstandard: "Past",
	},
	arceusfairy: {
		isNonstandard: "Past",
	},
	arceusfighting: {
		isNonstandard: "Past",
	},
	arceusfire: {
		isNonstandard: "Past",
	},
	arceusflying: {
		isNonstandard: "Past",
	},
	arceusghost: {
		isNonstandard: "Past",
	},
	arceusgrass: {
		isNonstandard: "Past",
	},
	arceusground: {
		isNonstandard: "Past",
	},
	arceusice: {
		isNonstandard: "Past",
	},
	arceuspoison: {
		isNonstandard: "Past",
	},
	arceuspsychic: {
		isNonstandard: "Past",
	},
	arceusrock: {
		isNonstandard: "Past",
	},
	arceussteel: {
		isNonstandard: "Past",
	},
	arceuswater: {
		isNonstandard: "Past",
	},
	victini: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	snivy: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	servine: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	serperior: {
		tier: "UU",
	},
	tepig: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pignite: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	emboar: {
		tier: "UU",
	},
	emboarmega: {
		tier: "UU",
	},
	oshawott: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dewott: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	samurott: {
		tier: "UU",
	},
	samurotthisui: {
		tier: "OU",
	},
	patrat: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	watchog: {
		tier: "UU",
	},
	lillipup: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	herdier: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	stoutland: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	purrloin: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	liepard: {
		tier: "UU",
	},
	pansage: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	simisage: {
		tier: "UU",
	},
	pansear: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	simisear: {
		tier: "UU",
	},
	panpour: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	simipour: {
		tier: "UU",
	},
	munna: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	musharna: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pidove: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tranquill: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	unfezant: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	blitzle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zebstrika: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	roggenrola: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	boldore: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	gigalith: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	woobat: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	swoobat: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	drilbur: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	excadrill: {
		tier: "OU",
	},
	excadrillmega: {
		tier: "(OU)",
	},
	audino: {
		tier: "UU",
	},
	audinomega: {
		tier: "UU",
	},
	timburr: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	gurdurr: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	conkeldurr: {
		tier: "UU",
	},
	tympole: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	palpitoad: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	seismitoad: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	throh: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sawk: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sewaddle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	swadloon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	leavanny: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	venipede: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	whirlipede: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	scolipede: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	scolipedemega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	cottonee: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	whimsicott: {
		tier: "UU",
	},
	petilil: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	lilligant: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	lilliganthisui: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	basculin: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	basculinbluestriped: {
		isNonstandard: "Past",
	},
	basculinwhitestriped: {
		isNonstandard: "Past",
	},
	basculegion: {
		tier: "OU",
	},
	basculegionf: {
		tier: "UU",
	},
	sandile: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	krokorok: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	krookodile: {
		tier: "UU",
	},
	darumaka: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	darumakagalar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	darmanitan: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	darmanitanzen: {
		isNonstandard: "Past",
	},
	darmanitangalar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	darmanitangalarzen: {
		isNonstandard: "Past",
	},
	maractus: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dwebble: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	crustle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	scraggy: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	scrafty: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	scraftymega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	sigilyph: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	yamask: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	yamaskgalar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cofagrigus: {
		tier: "UU",
	},
	runerigus: {
		tier: "UU",
	},
	tirtouga: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	carracosta: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	archen: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	archeops: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	trubbish: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	garbodor: {
		tier: "UU",
	},
	garbodorgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zorua: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zoruahisui: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zoroark: {
		tier: "UU",
	},
	zoroarkhisui: {
		tier: "UU",
	},
	minccino: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cinccino: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	gothita: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	gothorita: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	gothitelle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	solosis: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	duosion: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	reuniclus: {
		tier: "UU",
	},
	ducklett: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	swanna: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	vanillite: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	vanillish: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	vanilluxe: {
		tier: "UU",
	},
	deerling: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sawsbuck: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	emolga: {
		tier: "UU",
	},
	karrablast: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	escavalier: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	foongus: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	amoonguss: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	frillish: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	jellicent: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	alomomola: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	joltik: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	galvantula: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ferroseed: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ferrothorn: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	klink: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	klang: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	klinklang: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tynamo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	eelektrik: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	eelektross: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	eelektrossmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	elgyem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	beheeyem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	litwick: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	lampent: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	chandelure: {
		tier: "UU",
	},
	chandeluremega: {
		tier: "UU",
	},
	axew: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	fraxure: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	haxorus: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cubchoo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	beartic: {
		tier: "UU",
	},
	cryogonal: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	shelmet: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	accelgor: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	stunfisk: {
		tier: "UU",
	},
	stunfiskgalar: {
		tier: "UU",
	},
	mienfoo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mienshao: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	druddigon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	golett: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	golurk: {
		tier: "UU",
	},
	golurkmega: {
		tier: "UU",
	},
	pawniard: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	bisharp: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	bouffalant: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	rufflet: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	braviary: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	braviaryhisui: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	vullaby: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mandibuzz: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	heatmor: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	durant: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	deino: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zweilous: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	hydreigon: {
		tier: "OU",
	},
	larvesta: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	volcarona: {
		tier: "OU",
	},
	cobalion: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	terrakion: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	virizion: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tornadus: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tornadustherian: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	thundurus: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	thundurustherian: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	reshiram: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zekrom: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	landorus: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	landorustherian: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kyurem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kyuremblack: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kyuremwhite: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	keldeo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	keldeoresolute: {
		isNonstandard: "Past",
	},
	meloetta: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	genesect: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	genesectburn: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	genesectchill: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	genesectdouse: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	genesectshock: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	chespin: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	quilladin: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	chesnaught: {
		tier: "UU",
	},
	chesnaughtmega: {
		tier: "UU",
	},
	fennekin: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	braixen: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	delphox: {
		tier: "UU",
	},
	delphoxmega: {
		tier: "OU",
	},
	froakie: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	frogadier: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	greninja: {
		tier: "UU",
	},
	greninjaash: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	greninjabond: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	greninjamega: {
		tier: "UU",
	},
	bunnelby: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	diggersby: {
		tier: "UU",
	},
	fletchling: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	fletchinder: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	talonflame: {
		tier: "UU",
	},
	scatterbug: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	spewpa: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	vivillon: {
		tier: "UU",
	},
	litleo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pyroar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pyroarmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	flabebe: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	floette: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	floetteeternal: {
		tier: "UU",
	},
	floettemega: {
		tier: "OU",
	},
	florges: {
		tier: "UU",
	},
	skiddo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	gogoat: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pancham: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pangoro: {
		tier: "UU",
	},
	furfrou: {
		tier: "UU",
	},
	espurr: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	meowstic: {
		tier: "UU",
	},
	meowsticmmega: {
		tier: "UU",
	},
	meowsticfmega: {
		tier: "UU",
	},
	honedge: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	doublade: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	aegislash: {
		tier: "OU",
	},
	aegislashblade: {
	},
	spritzee: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	aromatisse: {
		tier: "UU",
	},
	swirlix: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	slurpuff: {
		tier: "UU",
	},
	inkay: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	malamar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	malamarmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	binacle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	barbaracle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	barbaraclemega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	skrelp: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dragalge: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dragalgemega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	clauncher: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	clawitzer: {
		tier: "UU",
	},
	helioptile: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	heliolisk: {
		tier: "UU",
	},
	tyrunt: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tyrantrum: {
		tier: "UU",
	},
	amaura: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	aurorus: {
		tier: "UU",
	},
	hawlucha: {
		tier: "UU",
	},
	hawluchamega: {
		tier: "UU",
	},
	dedenne: {
		tier: "UU",
	},
	carbink: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	goomy: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sliggoo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sliggoohisui: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	goodra: {
		tier: "UU",
	},
	goodrahisui: {
		tier: "UU",
	},
	klefki: {
		tier: "UU",
	},
	phantump: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	trevenant: {
		tier: "UU",
	},
	pumpkaboo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pumpkaboosmall: {
		isNonstandard: "Past",
	},
	pumpkaboolarge: {
		isNonstandard: "Past",
	},
	pumpkaboosuper: {
		isNonstandard: "Past",
	},
	gourgeist: {
		tier: "UU",
	},
	gourgeistsmall: {
		tier: "UU",
	},
	gourgeistlarge: {
		tier: "UU",
	},
	gourgeistsuper: {
		tier: "UU",
	},
	bergmite: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	avalugg: {
		tier: "UU",
	},
	avalugghisui: {
		tier: "UU",
	},
	noibat: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	noivern: {
		tier: "UU",
	},
	xerneas: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	xerneasneutral: {
		isNonstandard: "Custom", // can't be used in battle
		tier: "Illegal",
	},
	yveltal: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zygarde: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zygarde10: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zygardecomplete: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zygardemega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	diancie: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dianciemega: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	hoopa: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	hoopaunbound: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	volcanion: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	rowlet: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dartrix: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	decidueye: {
		tier: "UU",
	},
	decidueyehisui: {
		tier: "UU",
	},
	litten: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	torracat: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	incineroar: {
		tier: "UU",
	},
	popplio: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	brionne: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	primarina: {
		tier: "OU",
	},
	pikipek: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	trumbeak: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	toucannon: {
		tier: "UU",
	},
	yungoos: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	gumshoos: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	gumshoostotem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	grubbin: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	charjabug: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	vikavolt: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	vikavolttotem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	crabrawler: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	crabominable: {
		tier: "UU",
	},
	crabominablemega: {
		tier: "UU",
	},
	oricorio: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	oricoriopompom: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	oricoriopau: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	oricoriosensu: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cutiefly: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ribombee: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ribombeetotem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	rockruff: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	rockruffdusk: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	lycanroc: {
		tier: "UU",
	},
	lycanrocmidnight: {
		tier: "UU",
	},
	lycanrocdusk: {
		tier: "UU",
	},
	wishiwashi: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	wishiwashischool: {
		isNonstandard: "Past",
	},
	mareanie: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	toxapex: {
		tier: "OU",
	},
	mudbray: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mudsdale: {
		tier: "UU",
	},
	dewpider: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	araquanid: {
		tier: "OU",
	},
	araquanidtotem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	fomantis: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	lurantis: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	lurantistotem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	morelull: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	shiinotic: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	salandit: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	salazzle: {
		tier: "UU",
	},
	salazzletotem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	stufful: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	bewear: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	bounsweet: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	steenee: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tsareena: {
		tier: "UU",
	},
	comfey: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	oranguru: {
		tier: "UU",
	},
	passimian: {
		tier: "UU",
	},
	wimpod: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	golisopod: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	golisopodmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	sandygast: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	palossand: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pyukumuku: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	typenull: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	silvally: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	silvallybug: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	silvallydark: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	silvallydragon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	silvallyelectric: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	silvallyfairy: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	silvallyfighting: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	silvallyfire: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	silvallyflying: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	silvallyghost: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	silvallygrass: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	silvallyground: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	silvallyice: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	silvallypoison: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	silvallypsychic: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	silvallyrock: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	silvallysteel: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	silvallywater: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	minior: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	komala: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	turtonator: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	togedemaru: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	togedemarutotem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mimikyu: {
		tier: "UU",
	},
	mimikyutotem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mimikyubustedtotem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	bruxish: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	drampa: {
		tier: "UU",
	},
	drampamega: {
		tier: "UU",
	},
	dhelmise: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	jangmoo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	hakamoo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kommoo: {
		tier: "UU",
	},
	kommoototem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tapukoko: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tapulele: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tapubulu: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tapufini: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cosmog: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cosmoem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	solgaleo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	lunala: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	nihilego: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	buzzwole: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pheromosa: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	xurkitree: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	celesteela: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kartana: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	guzzlord: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	necrozma: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	necrozmaduskmane: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	necrozmadawnwings: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	necrozmaultra: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	magearna: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	magearnaoriginal: {
		isNonstandard: "Past",
	},
	magearnamega: {
		isNonstandard: "Future",
	},
	magearnaoriginalmega: {
		isNonstandard: "Future",
	},
	marshadow: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	poipole: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	naganadel: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	stakataka: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	blacephalon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zeraora: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zeraoramega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	meltan: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	melmetal: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	melmetalgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	grookey: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	thwackey: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	rillaboom: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	rillaboomgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	scorbunny: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	raboot: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cinderace: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cinderacegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sobble: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	drizzile: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	inteleon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	inteleongmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	skwovet: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	greedent: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	rookidee: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	corvisquire: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	corviknight: {
		tier: "OU",
	},
	corviknightgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	blipbug: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dottler: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	orbeetle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	orbeetlegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	nickit: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	thievul: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	gossifleur: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	eldegoss: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	wooloo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dubwool: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	chewtle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	drednaw: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	drednawgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	yamper: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	boltund: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	rolycoly: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	carkol: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	coalossal: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	coalossalgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	applin: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	flapple: {
		tier: "UU",
	},
	flapplegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	appletun: {
		tier: "UU",
	},
	appletungmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dipplin: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	silicobra: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sandaconda: {
		tier: "UU",
	},
	sandacondagmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cramorant: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	arrokuda: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	barraskewda: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	toxel: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	toxtricity: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	toxtricitylowkey: {
		isNonstandard: "Past",
	},
	toxtricitygmax: {
		isNonstandard: "Past",
	},
	toxtricitylowkeygmax: {
		isNonstandard: "Past",
	},
	sizzlipede: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	centiskorch: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	centiskorchgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	clobbopus: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	grapploct: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sinistea: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sinisteaantique: {
		isNonstandard: "Past",
	},
	polteageist: {
		tier: "UU",
	},
	hatenna: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	hattrem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	hatterene: {
		tier: "OU",
	},
	hatterenegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	impidimp: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	morgrem: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	grimmsnarl: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	grimmsnarlgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	milcery: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	alcremie: {
		tier: "UU",
	},
	alcremiegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	falinks: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	falinksmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	pincurchin: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	snom: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	frosmoth: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	stonjourner: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	eiscue: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	indeedee: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	indeedeef: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	morpeko: {
		tier: "UU",
	},
	cufant: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	copperajah: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	copperajahgmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dracozolt: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	arctozolt: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dracovish: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	arctovish: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	duraludon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	duraludongmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dreepy: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	drakloak: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dragapult: {
		tier: "OU",
	},
	zacian: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zaciancrowned: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zamazenta: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zamazentacrowned: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	eternatus: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	eternatuseternamax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kubfu: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	urshifu: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	urshifurapidstrike: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	urshifugmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	urshifurapidstrikegmax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zarude: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	zarudedada: {
		isNonstandard: "Past",
	},
	regieleki: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	regidrago: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	glastrier: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	spectrier: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	calyrex: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	calyrexice: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	calyrexshadow: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	enamorus: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	enamorustherian: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sprigatito: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	floragato: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	meowscarada: {
		tier: "OU",
	},
	fuecoco: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	crocalor: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	skeledirge: {
		tier: "UU",
	},
	quaxly: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	quaxwell: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	quaquaval: {
		tier: "OU",
	},
	lechonk: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	oinkologne: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	oinkolognef: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tarountula: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	spidops: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	nymble: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	lokix: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	rellor: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	rabsca: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	greavard: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	houndstone: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	flittle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	espathra: {
		tier: "UUBL",
	},
	wiglett: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	wugtrio: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dondozo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	veluza: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	finizen: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	palafin: {
		tier: "Uber",
	},
	smoliv: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dolliv: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	arboliva: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	capsakid: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	scovillain: {
		tier: "UU",
	},
	scovillainmega: {
		tier: "UU",
	},
	tadbulb: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	bellibolt: {
		tier: "UU",
	},
	varoom: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	revavroom: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	orthworm: {
		tier: "UU",
	},
	tandemaus: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	maushold: {
		tier: "UU",
	},
	cetoddle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	cetitan: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	frigibax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	arctibax: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	baxcalibur: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	baxcaliburmega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	tatsugiri: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tatsugiridroopy: {
		isNonstandard: "Past",
	},
	tatsugiristretchy: {
		isNonstandard: "Past",
	},
	tatsugiricurlymega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	tatsugiridroopymega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	tatsugiristretchymega: {
		isNonstandard: "Future",
		tier: "Illegal",
	},
	cyclizar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pawmi: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pawmo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pawmot: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	wattrel: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kilowattrel: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	bombirdier: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	squawkabilly: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	squawkabillyblue: {
		isNonstandard: "Past",
	},
	squawkabillyyellow: {
		isNonstandard: "Past",
	},
	squawkabillywhite: {
		isNonstandard: "Past",
	},
	flamigo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	klawf: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	nacli: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	naclstack: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	garganacl: {
		tier: "UU",
	},
	glimmet: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	glimmora: {
		tier: "OU",
	},
	glimmoramega: {
		tier: "OU",
	},
	shroodle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	grafaiai: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	fidough: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	dachsbun: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	maschiff: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	mabosstiff: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	bramblin: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	brambleghast: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	gimmighoul: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	gimmighoulroaming: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	gholdengo: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	greattusk: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	brutebonnet: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	sandyshocks: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	screamtail: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	fluttermane: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	slitherwing: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	roaringmoon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	irontreads: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ironmoth: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ironhands: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ironjugulis: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ironthorns: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ironbundle: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ironvaliant: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tinglu: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	chienpao: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	wochien: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	chiyu: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	koraidon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	miraidon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tinkatink: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tinkatuff: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	tinkaton: {
		tier: "UU",
	},
	charcadet: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	armarouge: {
		tier: "UU",
	},
	ceruledge: {
		tier: "OU",
	},
	toedscool: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	toedscruel: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	kingambit: {
		tier: "OU",
	},
	clodsire: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	annihilape: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	walkingwake: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ironleaves: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	poltchageist: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	poltchageistartisan: {
		isNonstandard: "Past",
	},
	sinistcha: {
		tier: "UU",
	},
	okidogi: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	munkidori: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	fezandipiti: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ogerpon: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ogerponwellspring: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ogerponhearthflame: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ogerponcornerstone: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	archaludon: {
		tier: "OU",
	},
	hydrapple: {
		tier: "UU",
	},
	gougingfire: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ragingbolt: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ironboulder: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	ironcrown: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	terapagos: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	terapagosstellar: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
	pecharunt: {
		isNonstandard: "Past",
		tier: "Illegal",
	},
};
